import useSWR, { KeyedMutator } from 'swr';
import { SWRFetcher } from '@commenda/utils';
import { IFileFolder } from './types';

export default function useFileFolder(fileFolderId: string, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: IFileFolder;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `fileFolder/${fileFolderId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
